module.exports = __webpack_public_path__ + "static/media/ufo.53ba10e6.mp3";